export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=59f4e394"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/branches/branch/bonuses/index.vue?vue&type=template&id=59f4e394
// module id = Ma7/
// module chunks = 0